import React, { useState, useEffect } from 'react';
import apiService from '../services/api';
import useFavorites from '../hooks/useFavorites';
import Icon from '../components/icons/Icon';
import './StandingsPage.css';

const LEAGUE_TABS = [
  { id: 'epl',    label: 'Premier League' },
  { id: 'laliga', label: 'La Liga' },
  { id: 'serie',  label: 'Serie A' },
  { id: 'bundes', label: 'Bundesliga' },
  { id: 'ligue1', label: 'Ligue 1' },
];

const FormBadge = ({ result }) => (
  <span className={`form-badge form-${result.toLowerCase()}`}>{result}</span>
);

export default function StandingsPage() {
  const [activeLeague, setActiveLeague] = useState('epl');
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { isTeamFav, toggleTeam } = useFavorites();

  useEffect(() => {
    setLoading(true);
    apiService.getStandings(activeLeague).then(res => {
      setData(res);
      setLoading(false);
    });
  }, [activeLeague]);

  return (
    <div className="standings-page">
      <div className="standings-page-header">
        <h1>League Standings</h1>
        <p className="page-sub">Live tables across Europe's top leagues</p>
      </div>

      <div className="league-tabs">
        {LEAGUE_TABS.map(t => (
          <button
            key={t.id}
            className={`league-tab ${activeLeague === t.id ? 'active' : ''}`}
            onClick={() => setActiveLeague(t.id)}
          >
            {t.label}
          </button>
        ))}
      </div>

      {loading && <div className="loading-state">Loading…</div>}

      {!loading && data?.table && (
        <div className="standings-card">
          <div className="standings-card-header">
            <img src={data.league?.logo} alt="" />
            <div>
              <h2>{data.league?.name}</h2>
              <p>{data.league?.country}</p>
            </div>
          </div>

          <div className="standings-scroll">
            <table className="full-standings-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th className="team-col">Team</th>
                  <th>P</th>
                  <th>W</th>
                  <th>D</th>
                  <th>L</th>
                  <th>GF</th>
                  <th>GA</th>
                  <th>GD</th>
                  <th>Pts</th>
                  <th className="form-col">Form</th>
                </tr>
              </thead>
              <tbody>
                {data.table.map((row, i) => {
                  const pos = i + 1;
                  let zoneClass = '';
                  if (pos <= 4) zoneClass = 'ucl-zone';
                  else if (pos <= 6) zoneClass = 'el-zone';
                  else if (pos >= data.table.length - 2) zoneClass = 'rel-zone';

                  return (
                    <tr key={row.team.id} className={zoneClass}>
                      <td className="pos">{pos}</td>
                      <td className="team-col">
                        <button
                          className={`fav-star ${isTeamFav(row.team.id) ? 'active' : ''}`}
                          onClick={() => toggleTeam(row.team.id)}
                          title={isTeamFav(row.team.id) ? 'Unfollow' : 'Follow team'}
                          aria-label="Toggle favorite team"
                        >
                          <Icon name="star" size={14} />
                        </button>
                        <img src={row.team.logo} alt="" />
                        <span>{row.team.name}</span>
                      </td>
                      <td>{row.p}</td>
                      <td>{row.w}</td>
                      <td>{row.d}</td>
                      <td>{row.l}</td>
                      <td>{row.gf}</td>
                      <td>{row.ga}</td>
                      <td className={row.gd >= 0 ? 'gd-pos' : 'gd-neg'}>
                        {row.gd > 0 ? '+' : ''}{row.gd}
                      </td>
                      <td className="pts">{row.pts}</td>
                      <td className="form-col">
                        <div className="form-row">
                          {row.form.split('').map((r, idx) => <FormBadge key={idx} result={r} />)}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          <div className="standings-legend">
            <span><i className="legend-dot ucl"></i> Champions League</span>
            <span><i className="legend-dot el"></i> Europa League</span>
            <span><i className="legend-dot rel"></i> Relegation</span>
          </div>
        </div>
      )}
    </div>
  );
}
